import React from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter, flexDirection, mb, onDesktop} from "@pg-design/helpers-css";
import {SunIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";

import {DaylightLevel} from "../../hooks/use_property_planner_estate_details";
import {PropertyLocationGeneralAttributeBox} from "./PropertyLocationGeneralAttributeBox";

const daylightStandardImg = require("../../images/daylight/daylight_standard.svg");
const daylightGoodImg = require("../../images/daylight/daylight_good.svg");
const daylightVeryGoodImg = require("../../images/daylight/daylight_very_good.svg");
const daylightExcellentImg = require("../../images/daylight/daylight_excellent.svg");

interface IProps {
    sunshineLevel: DaylightLevel;
}

export const PropertyLocationDaylight = (props: IProps) => {
    const {img, title, description} = daylightLevels[props.sunshineLevel];
    return (
        <PropertyLocationGeneralAttributeBox
            graphic={
                <div css={propertyDaylightGraphicStyle}>
                    <div css={iconWrapperStyle}>
                        <SunIcon size="2.2" />
                    </div>
                    <Image src={img} width="130px" height="82px" css={daylightInfographicStyle} alt="Nasłonecznienie" />
                </div>
            }
            title={title}
            description={description}
        />
    );
};

const daylightLevels = {
    [DaylightLevel.STANDARD]: {
        img: daylightStandardImg,
        label: "Standardowe nasłonecznienie",
        title: "Standardowe nasłonecznienie",
        description: "Mieszkanie zostało optymalnie zaprojektowane do codziennego funkcjonowania i spełnia standardy rynkowe."
    },
    [DaylightLevel.GOOD]: {
        img: daylightGoodImg,
        label: "Dobre nasłonecznienie",
        title: "Dobre nasłonecznienie",
        description: "Współczynnik nasłonecznienia tego mieszkania przewyższa średnią rynkową dla pomieszczeń mieszkalnych."
    },
    [DaylightLevel.VERY_GOOD]: {
        img: daylightVeryGoodImg,
        label: "Bardzo dobre nasłonecznienie",
        title: "Bardzo dobre nasłonecznienie",
        description: "Współczynnik nasłonecznienia tego mieszkania znacząco przewyższa średnią rynkową dla pomieszczeń mieszkalnych."
    },
    [DaylightLevel.EXCELLENT]: {
        img: daylightExcellentImg,
        label: "Świetne nasłonecznienie",
        title: "Świetne nasłonecznienie",
        description:
            "Współczynnik nasłonecznienia tego mieszkania przewyższa średnią rynkową dla pomieszczeń mieszkalnych o ponad 100%. Oznacza to, że nieruchomość będzie znakomicie doświetlona oraz wyróżni się spośród tradycyjnych ofert. "
    }
};

const propertyDaylightGraphicStyle = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
`;

const daylightInfographicStyle = css`
    width: 110px;
    height: 70px;

    & > img {
        width: 100%;
        height: 100%;
    }

    ${onDesktop(css`
        width: 130px;
        height: 82px;
    `)};
`;

const iconWrapperStyle = css`
    ${mb(1.5)};
    ${flexAbsoluteCenter};
    height: 2.2rem;
`;
import React from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter, flexDirection, mb, onDesktop} from "@pg-design/helpers-css";
import {SunIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";

import {DaylightLevel} from "../../hooks/use_property_planner_estate_details";
import {PropertyLocationGeneralAttributeBox} from "./PropertyLocationGeneralAttributeBox";

const daylightStandardImg = require("../../images/daylight/daylight_standard.svg");
const daylightGoodImg = require("../../images/daylight/daylight_good.svg");
const daylightVeryGoodImg = require("../../images/daylight/daylight_very_good.svg");
const daylightExcellentImg = require("../../images/daylight/daylight_excellent.svg");

interface IProps {
    sunshineLevel: DaylightLevel;
}

export const PropertyLocationDaylight = (props: IProps) => {
    const {img, title, description} = daylightLevels[props.sunshineLevel];
    return (
        <PropertyLocationGeneralAttributeBox
            graphic={
                <div css={propertyDaylightGraphicStyle}>
                    <div css={iconWrapperStyle}>
                        <SunIcon size="2.2" />
                    </div>
                    <Image src={img} width="130px" height="82px" css={daylightInfographicStyle} alt="Nasłonecznienie" />
                </div>
            }
            title={title}
            description={description}
        />
    );
};

const daylightLevels = {
    [DaylightLevel.STANDARD]: {
        img: daylightStandardImg,
        label: "Standardowe nasłonecznienie",
        title: "Standardowe nasłonecznienie",
        description: "Mieszkanie zostało optymalnie zaprojektowane do codziennego funkcjonowania i spełnia standardy rynkowe."
    },
    [DaylightLevel.GOOD]: {
        img: daylightGoodImg,
        label: "Dobre nasłonecznienie",
        title: "Dobre nasłonecznienie",
        description: "Współczynnik nasłonecznienia tego mieszkania przewyższa średnią rynkową dla pomieszczeń mieszkalnych."
    },
    [DaylightLevel.VERY_GOOD]: {
        img: daylightVeryGoodImg,
        label: "Bardzo dobre nasłonecznienie",
        title: "Bardzo dobre nasłonecznienie",
        description: "Współczynnik nasłonecznienia tego mieszkania znacząco przewyższa średnią rynkową dla pomieszczeń mieszkalnych."
    },
    [DaylightLevel.EXCELLENT]: {
        img: daylightExcellentImg,
        label: "Świetne nasłonecznienie",
        title: "Świetne nasłonecznienie",
        description:
            "Współczynnik nasłonecznienia tego mieszkania przewyższa średnią rynkową dla pomieszczeń mieszkalnych o ponad 100%. Oznacza to, że nieruchomość będzie znakomicie doświetlona oraz wyróżni się spośród tradycyjnych ofert. "
    }
};

const propertyDaylightGraphicStyle = css`
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
`;

const daylightInfographicStyle = css`
    width: 110px;
    height: 70px;

    & > img {
        width: 100%;
        height: 100%;
    }

    ${onDesktop(css`
        width: 130px;
        height: 82px;
    `)};
`;

const iconWrapperStyle = css`
    ${mb(1.5)};
    ${flexAbsoluteCenter};
    height: 2.2rem;
`;
